<template  >


    <v-container style="width:100vw;height:100vh;background: #373737;" >


                <v-row align="center" justify="center" class="mx-auto" style="margin-top:100px;max-width:1000px;">
                    <v-btn dark class="text-lowercase font-weight-light" router
                           :to="'/admin'" tile text>
                        Stats
                    </v-btn>

                    <v-btn dark router :to="'/db-admin'" class="text-lowercase font-weight-light"  text>
                        DB
                    </v-btn>
                  <v-btn dark router :to="'/admin_payouts'" class="text-lowercase font-weight-light"  text>
                    Payouts
                  </v-btn>
                  <v-btn dark router :to="'/admin_spons'" class="text-lowercase font-weight-light"  text>
                    Spons
                  </v-btn>


                    <v-col cols="12" align="center">
                        <v-card   >
                            <v-row>

                                <v-col cols="12">
                                    <v-btn dark large @click="refresh" icon style="position:absolute;right:-5px;z-index: 2;top:-40px;"><v-icon>mdi-refresh</v-icon></v-btn>

                                    <v-tabs v-model="tab" centered color="black">
                                        <v-tab>
                                            Dag
                                        </v-tab>
                                        <v-tab>
                                            Vecka
                                        </v-tab>
                                        <v-tab>
                                            Månad
                                        </v-tab>
                                        <v-tab>
                                            All time
                                        </v-tab>

                                    </v-tabs>

                                </v-col>
                            </v-row>
                            <v-divider></v-divider>

                            <v-card-subtitle style="text-align:center;padding-bottom: 0;background: #a6a6a6; color: white; padding-top: 0;">Performance</v-card-subtitle>
                            <v-row style="padding-top: 20px; padding-bottom: 20px;">

                                <v-col :cols="$vuetify.breakpoint.mdAndUp? '3':'6'">
                                    Vinst
                                    <h2>{{profit.value}} kr </h2>
                                    <span v-if="tab!==3">
                                        <span style="color:#189f67;" v-if="profit.change>=0">+ {{profit.change}} %</span>
                                        <span style="color:#ff0e52;" v-else>{{profit.change}} %</span>
                                    </span>
                                    <span style="height:24px;display:block;" v-else>

                                    </span>

                                </v-col>
                                <v-col :cols="$vuetify.breakpoint.mdAndUp? '3':'6'">
                                    Transaktioner
                                    <h2>{{transactions.value}}</h2>
                                    <span v-if="tab!==3">
                                        <span style="color:#189f67;" v-if="transactions.change>=0">+ {{transactions.change}} %</span>
                                        <span style="color:#ff0e52;" v-else>{{transactions.change}} %</span>
                                    </span>
                                </v-col>
                                <v-col v-if="tab>0" :cols="$vuetify.breakpoint.mdAndUp? '3':'6'">
                                    Flöde
                                    <h2>{{flow.value}} kr </h2>
                                    <span v-if="tab!==3">
                                        <span style="color:#189f67;" v-if="flow.change>=0">+ {{flow.change}} %</span>
                                        <span style="color:#ff0e52;" v-else>{{flow.change}} %</span>
                                    </span>

                                    <span style="height:24px;display:block;" v-else>

                                    </span>
                                </v-col>
                              <v-col v-else :cols="$vuetify.breakpoint.mdAndUp? '3':'6'">
                                Flöde
                                <h2>{{flow.value}} /({{today_gross}}) kr </h2>

                                <span v-if="tab!==3">
                                        <span style="color:#189f67;" v-if="flow.change>=0">+ {{flow.change}} %</span>
                                        <span style="color:#ff0e52;" v-else>{{flow.change}} %</span>
                                    </span>

                                <span style="height:24px;display:block;" v-else>

                                    </span>
                              </v-col>
                                <v-col :cols="$vuetify.breakpoint.mdAndUp? '3':'6'">
                                    Streamers
                                    <h2>{{streamers.value}}</h2>
                                    <span v-if="tab!==3">
                                        <span style="color:#189f67;" v-if="streamers.change>=0">+ {{streamers.change}} %</span>
                                        <span style="color:#ff0e52;" v-else>{{streamers.change}} %</span>
                                    </span>


                                </v-col>
                            </v-row>

                            <v-divider></v-divider>
                            <v-card-subtitle style="text-align:center;padding-bottom: 0;text-align:center;padding-bottom: 0;background: #a6a6a6;; color: white; padding-top: 0;">Top earners</v-card-subtitle>
                            <div v-if="top_streamers!==null">
                            <v-tabs-items v-model="tab" >
                                <v-tab-item >
                                    <v-row style="padding-top: 60px; padding-bottom: 20px;">
                                        <v-col   v-for="(streamer,index) in top_streamers[0].slice(0,4)" :key="index" :cols="$vuetify.breakpoint.mdAndUp? '3':'6'">
                                            <v-list-item>
                                                <v-list-item-avatar color="grey"><v-img><img :src="'/api/images/users/'+streamer.RECIPIENT+'.png'" @error="function(event){alternate_image(event,streamer.USER_NAME)}"/></v-img></v-list-item-avatar>
                                                <v-list-item-content style="text-align: left;">
                                                    <v-list-item-title><h3>{{streamer.USER_NAME}}</h3></v-list-item-title>
                                                    <v-list-item-subtitle>{{parseInt(streamer.EARNED_US)}} kr ({{parseInt((streamer.EARNED_US/profit.value)*100)}}%)</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-col>
                                        <div style="width:100%;margin-left: 12px; margin-right: 12px; left: 2em;">
                                        <v-expansion-panels flat>
                                            <v-expansion-panel >
                                                <v-expansion-panel-content>
                                                    <v-row style="margin-left: -34px;margin-right: -36px;">
                                                    <v-col  v-for="(streamer,index) in top_streamers[0].slice(4)" :key="index" :cols="$vuetify.breakpoint.mdAndUp? '3':'6'">
                                                        <v-list-item>
                                                            <v-list-item-avatar color="grey"><v-img><img :src="'/api/images/users/'+streamer.RECIPIENT+'.png'" @error="function(event){alternate_image(event,streamer.USER_NAME)}"/></v-img></v-list-item-avatar>
                                                            <v-list-item-content style="text-align: left;">
                                                                <v-list-item-title><h3>{{streamer.USER_NAME}}</h3></v-list-item-title>
                                                                <v-list-item-subtitle>{{parseInt(streamer.EARNED_US)}} kr ({{parseInt((streamer.EARNED_US/profit.value)*100)}}%)</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-col>
                                                    </v-row>
                                                </v-expansion-panel-content>
                                                <v-expansion-panel-header style=""></v-expansion-panel-header>

                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        </div>
                                    </v-row>

                                </v-tab-item>
                                <v-tab-item >
                                    <v-row style="padding-top: 60px; padding-bottom: 20px;">
                                        <v-col   v-for="(streamer,index) in top_streamers[1].slice(0,4)" :key="index" :cols="$vuetify.breakpoint.mdAndUp? '3':'6'">
                                            <v-list-item>
                                                <v-list-item-avatar color="grey"><v-img><img :src="'/api/images/users/'+streamer.RECIPIENT+'.png'" @error="function(event){alternate_image(event,streamer.USER_NAME)}"/></v-img></v-list-item-avatar>
                                                <v-list-item-content style="text-align: left;">
                                                    <v-list-item-title><h3>{{streamer.USER_NAME}}</h3></v-list-item-title>
                                                    <v-list-item-subtitle>{{parseInt(streamer.EARNED_US)}} kr ({{parseInt((streamer.EARNED_US/profit.value)*100)}}%)</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-col>
                                        <div style="width:100%;margin-left: 12px; margin-right: 12px; left: 2em;">
                                            <v-expansion-panels flat>
                                                <v-expansion-panel >
                                                    <v-expansion-panel-content>
                                                        <v-row style="margin-left: -34px;margin-right: -36px;">
                                                            <v-col  v-for="(streamer,index) in top_streamers[1].slice(4)" :key="index" :cols="$vuetify.breakpoint.mdAndUp? '3':'6'">
                                                                <v-list-item>
                                                                    <v-list-item-avatar color="grey"><v-img><img :src="'/api/images/users/'+streamer.RECIPIENT+'.png'" @error="function(event){alternate_image(event,streamer.USER_NAME)}"/></v-img></v-list-item-avatar>
                                                                    <v-list-item-content style="text-align: left;">
                                                                        <v-list-item-title><h3>{{streamer.USER_NAME}}</h3></v-list-item-title>
                                                                        <v-list-item-subtitle>{{parseInt(streamer.EARNED_US)}} kr ({{parseInt((streamer.EARNED_US/profit.value)*100)}}%)</v-list-item-subtitle>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-col>
                                                        </v-row>
                                                    </v-expansion-panel-content>
                                                    <v-expansion-panel-header style=""></v-expansion-panel-header>

                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </div>
                                    </v-row>

                                </v-tab-item>
                                <v-tab-item >
                                    <v-row style="padding-top: 60px; padding-bottom: 20px;">
                                        <v-col   v-for="(streamer,index) in top_streamers[2].slice(0,4)" :key="index" :cols="$vuetify.breakpoint.mdAndUp? '3':'6'">
                                            <v-list-item>
                                                <v-list-item-avatar color="grey"><v-img><img :src="'/api/images/users/'+streamer.RECIPIENT+'.png'" @error="function(event){alternate_image(event,streamer.USER_NAME)}"/></v-img></v-list-item-avatar>
                                                <v-list-item-content style="text-align: left;">
                                                    <v-list-item-title><h3>{{streamer.USER_NAME}}</h3></v-list-item-title>
                                                    <v-list-item-subtitle>{{parseInt(streamer.EARNED_US)}} kr ({{parseInt((streamer.EARNED_US/profit.value)*100)}}%)</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-col>
                                        <div style="width:100%;margin-left: 12px; margin-right: 12px; left: 2em;">
                                            <v-expansion-panels flat>
                                                <v-expansion-panel >
                                                    <v-expansion-panel-content>
                                                        <v-row style="margin-left: -34px;margin-right: -36px;">
                                                            <v-col  v-for="(streamer,index) in top_streamers[2].slice(4)" :key="index" :cols="$vuetify.breakpoint.mdAndUp? '3':'6'">
                                                                <v-list-item>
                                                                    <v-list-item-avatar color="grey"><v-img><img :src="'/api/images/users/'+streamer.RECIPIENT+'.png'" @error="function(event){alternate_image(event,streamer.USER_NAME)}"/></v-img></v-list-item-avatar>
                                                                    <v-list-item-content style="text-align: left;">
                                                                        <v-list-item-title><h3>{{streamer.USER_NAME}}</h3></v-list-item-title>
                                                                        <v-list-item-subtitle>{{parseInt(streamer.EARNED_US)}} kr ({{parseInt((streamer.EARNED_US/profit.value)*100)}}%)</v-list-item-subtitle>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-col>
                                                        </v-row>
                                                    </v-expansion-panel-content>
                                                    <v-expansion-panel-header style=""></v-expansion-panel-header>

                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </div>
                                    </v-row>

                                </v-tab-item>
                                <v-tab-item >
                                    <v-row style="padding-top: 60px; padding-bottom: 20px;">
                                        <v-col   v-for="(streamer,index) in top_streamers[3].slice(0,4)" :key="index" :cols="$vuetify.breakpoint.mdAndUp? '3':'6'">
                                            <v-list-item>
                                                <v-list-item-avatar color="grey"><v-img><img :src="'/api/images/users/'+streamer.RECIPIENT+'.png'" @error="function(event){alternate_image(event,streamer.USER_NAME)}"/></v-img></v-list-item-avatar>
                                                <v-list-item-content style="text-align: left;">
                                                    <v-list-item-title><h3>{{streamer.USER_NAME}}</h3></v-list-item-title>
                                                    <v-list-item-subtitle>{{parseInt(streamer.EARNED_US)}} kr ({{((streamer.EARNED_US/profit.value)*100).toFixed(1)}}%)</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-col>
                                        <div style="width:100%;margin-left: 12px; margin-right: 12px; left: 2em;">
                                            <v-expansion-panels flat>
                                                <v-expansion-panel >
                                                    <v-expansion-panel-content>
                                                        <v-row style="margin-left: -34px;margin-right: -36px;">
                                                            <v-col  v-for="(streamer,index) in top_streamers[3].slice(4)" :key="index" :cols="$vuetify.breakpoint.mdAndUp? '3':'6'">
                                                                <v-list-item>
                                                                    <v-list-item-avatar color="grey"><v-img><img :src="'/api/images/users/'+streamer.RECIPIENT+'.png'" @error="function(event){alternate_image(event,streamer.USER_NAME)}"/></v-img></v-list-item-avatar>
                                                                    <v-list-item-content style="text-align: left;">
                                                                        <v-list-item-title><h3>{{streamer.USER_NAME}}</h3></v-list-item-title>
                                                                        <v-list-item-subtitle>{{parseInt(streamer.EARNED_US)}} kr ({{((streamer.EARNED_US/profit.value)*100).toFixed(1)}}%)</v-list-item-subtitle>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-col>
                                                        </v-row>
                                                    </v-expansion-panel-content>
                                                    <v-expansion-panel-header style=""></v-expansion-panel-header>

                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </div>
                                    </v-row>

                                </v-tab-item>
                            </v-tabs-items>
                            </div>

                            <v-divider></v-divider>
                            <v-card-subtitle style="text-align:center;padding-bottom: 0;text-align:center;padding-bottom: 0;background: #a6a6a6;; color: white; padding-top: 0;">Betalningar</v-card-subtitle>
                            <v-row style="padding-top: 20px; padding-bottom: 20px;">
                                <v-col cols="6">
                                    Success
                                    <h2>{{payment_success_rate.value}}%</h2>
                                    <span v-if="tab!==3">
                                        <span style="color:#189f67;" v-if="payment_success_rate.change>=0">+ {{payment_success_rate.change}} %</span>
                                        <span style="color:#ff0e52;" v-else>{{payment_success_rate.change}} %</span>
                                    </span>

                                    <span style="height:24px;display:block;" v-else>

                                    </span>


                                </v-col>
                                <v-col cols="6">
                                    Error
                                    <h2>{{payment_fail_rate.value}}%</h2>
                                    <span v-if="tab!==3">
                                        <span style="color:#ff0e52;" v-if="payment_fail_rate.change>=0">+ {{payment_fail_rate.change}} %</span>
                                        <span style="color:#189f67;" v-else>{{payment_fail_rate.change}} %</span>
                                    </span>

                                    <span style="height:24px;display:block;" v-else>

                                    </span>
                                </v-col>


                            </v-row>

                            <v-card-subtitle style="text-align:center;padding-bottom: 0;text-align:center;padding-bottom: 0;background: #a6a6a6;; color: white; padding-top: 0;">Notiser</v-card-subtitle>
                            <v-row style="padding-top: 20px; padding-bottom: 20px;">
                                <v-col cols="6">
                                    Success
                                    <h2>{{message_success_rate.value}}%</h2>
                                    <span v-if="tab!==3">
                                        <span style="color:#189f67;" v-if="message_success_rate.change>=0">+ {{message_success_rate.change}} %</span>
                                        <span style="color:#ff0e52;" v-else>{{message_success_rate.change}} %</span>
                                    </span>

                                    <span style="height:24px;display:block;" v-else>

                                    </span>


                                </v-col>
                                <v-col cols="6">
                                    Error
                                    <h2>{{message_fail_rate.value}}%</h2>
                                    <span v-if="tab!==3">
                                        <span style="color:#ff0e52;" v-if="message_fail_rate.change>=0">+ {{message_fail_rate.change}} %</span>
                                        <span style="color:#189f67;" v-else>{{message_fail_rate.change}} %</span>
                                    </span>

                                    <span style="height:24px;display:block;" v-else>

                                    </span>
                                </v-col>


                            </v-row>

                        </v-card>
                    </v-col>

                </v-row>




    </v-container>

</template>

<script>


    export default {
        name: "Admin",
        components:{},
        data:function(){
            return{
                today_gross:0,
                tab:0,
                date_menu:null,
                date:[],
                general_stats:null,
                top_streamers:null,
                payment_status:null,
                message_status:null



            }
        },
        methods:{
            get_general_stats:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;


                let url = '/api/generalStats';
                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function () {//Call a function when the state changes.


                    if (http.readyState === 4 && http.status === 200) {
                        let respObj = JSON.parse(http.response);
                        self.general_stats=respObj;
                    }

                };
                http.send();
            },
            get_top_streamers:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;


                let url = '/api/top_streamers';
                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function () {//Call a function when the state changes.


                    if (http.readyState === 4 && http.status === 200) {
                        let respObj = JSON.parse(http.response);
                        self.top_streamers=respObj;
                    }

                };
                http.send();
            },

            get_payment_status:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;


                let url = '/api/payment_status';
                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function () {//Call a function when the state changes.


                    if (http.readyState === 4 && http.status === 200) {
                        let respObj = JSON.parse(http.response);
                        self.payment_status=respObj;
                        self.today_gross=respObj[4]["flow_today"];
                    }

                };
                http.send();
            },
            get_message_status:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;


                let url = '/api/messages_status';
                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function () {//Call a function when the state changes.


                    if (http.readyState === 4 && http.status === 200) {
                        let respObj = JSON.parse(http.response);
                        console.log(respObj);
                        self.message_status=respObj;
                    }

                };
                http.send();
            },
            alternate_image:function(event,user_name){
                event.target.src = `/api/avatar/${user_name.toLowerCase()}`

            },
            refresh:function(){
                this.get_general_stats();
                this.get_top_streamers();
                this.get_payment_status();
                this.get_message_status();
            }


        },
        computed:{
            profit:function(){
                if(this.general_stats){
                    let change=parseInt(this.general_stats[this.tab]["Vinst"])/parseInt(this.general_stats[this.tab]["Vinst2"])-1;
                    change=parseInt(change*100);


                    return {value:parseInt(this.general_stats[this.tab]["Vinst"]),change:change}
                }
                else{
                    return 0
                }

            },
            transactions:function(){
                if(this.general_stats){
                    let change=parseInt(this.general_stats[this.tab]["Transaktioner"])/parseInt(this.general_stats[this.tab]["Transaktioner2"])-1;
                    change=parseInt(change*100);


                    return {value:parseInt(this.general_stats[this.tab]["Transaktioner"]),change:change}
                }
                else{
                    return 0
                }

            },
            flow:function(){
                if(this.general_stats){
                    let change=parseInt(this.general_stats[this.tab]["Flow"])/parseInt(this.general_stats[this.tab]["Flow2"])-1;
                    change=parseInt(change*100);


                    return {value:parseInt(this.general_stats[this.tab]["Flow"]),change:change}
                }
                else{
                    return 0
                }

            },
            streamers:function(){
                if(this.general_stats){
                    let change=parseInt(this.general_stats[this.tab]["Streamers"])/parseInt(this.general_stats[this.tab]["Streamers2"])-1;
                    change=parseInt(change*100);


                    return {value:parseInt(this.general_stats[this.tab]["Streamers"]),change:change}
                }
                else{
                    return 0
                }

            },
            payment_success_rate:function(){
                if(this.payment_status){
                    let value=parseInt(this.payment_status[this.tab]["paid"])/parseInt(this.payment_status[this.tab]["total"]);
                    value=(value*100)

                    let change=parseInt(this.payment_status[3]["paid"])/parseInt(this.payment_status[3]["total"]);
                    change=value-parseInt(change*100);


                    return {value:value.toFixed(1),change:change.toFixed(1)}
                }
                else{
                    return 0
                }
            },
            payment_fail_rate:function(){
                if(this.payment_status){
                    let value=parseInt(this.payment_status[this.tab]["failed"])/parseInt(this.payment_status[this.tab]["total"]);
                    value=(value*100)

                    let change=parseInt(this.payment_status[3]["failed"])/parseInt(this.payment_status[3]["total"]);
                    change=(value-parseInt(change*100))


                    return {value:value.toFixed(1),change:change.toFixed(1)}
                }
                else{
                    return 0
                }
            },

            message_success_rate:function(){
                if(this.message_status){
                    let value=parseInt(this.message_status[this.tab]["done"])/parseInt(this.message_status[this.tab]["total"]);
                    value=(value*100)

                    let change=parseInt(this.message_status[3]["done"])/parseInt(this.message_status[3]["total"]);
                    change=(value-parseInt(change*100))


                    return {value:value.toFixed(1),change:change.toFixed(1)}
                }
                else{
                    return 0
                }
            },
            message_fail_rate:function(){
                if(this.message_status){
                    let value=parseInt(this.message_status[this.tab]["failed"])/parseInt(this.message_status[this.tab]["total"]);
                    value=(value*100);

                    let change=parseInt(this.message_status[3]["failed"])/parseInt(this.message_status[3]["total"]);
                    change=value-parseInt(change*100);


                    return {value:value.toFixed(1),change:change.toFixed(1)}
                }
                else{
                    return 0
                }
            },

        },
        watch:{
            date:function(){

            }
        },
        mounted:function(){
            let self=this;
            setTimeout(function(){
                if(!self.$store.state.STREAMER.IS_ADMIN){
                    self.$router.push(`/404`)

                }
            },1000);
            this.get_general_stats();
            this.get_top_streamers();
            this.get_payment_status();
            this.get_message_status();

        }

    }
</script>

<style >
    .v-tabs-bar{
        background: transparent !important;
    }

    .theme--dark.v-data-table tbody tr:hover{
        background: rgba(255,255,255,0.1) !important;
    }

    .fillme{
        background: black;
    }
</style>
